import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface EmPuzzleIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const EmPuzzleIcon = ({ className, ...props }: EmPuzzleIconProps) => (
  <svg
    className={cn(className)}
    fill="none"
    height="22"
    viewBox="0 0 22 22"
    width="22"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.62721 10.2781C5.55502 10.2059 1.16018 9.23828 1.16018 9.23828C1.16018 9.23828 0.904085 9.64906 0.977991 9.89141C1.01924 10.0272 1.9783 11.1427 2.96487 12.1688C3.74346 12.98 4.62862 13.805 4.75752 14.2759C4.95518 15.0012 4.9758 16.1648 4.9758 16.1648L2.11065 17.9145C2.11065 17.9145 2.46127 19.6986 4.73346 19.6281C6.85612 19.5628 6.96612 17.3147 7.63987 17.3027C7.7533 17.3009 7.90971 17.2614 8.18987 17.5622C8.88424 18.3081 10.1836 19.7484 10.6185 20.185C11.1994 20.7659 11.6119 21.3469 11.8302 21.3228C12.0485 21.2987 13.8892 19.6522 14.4221 19.1434C14.9549 18.6347 15.4396 18.0297 15.4396 17.5209C15.4396 17.0122 14.6885 16.6255 14.6885 16.6255L10.5463 17.1102L5.62721 10.2781Z"
      fill="#B0B0AF"
    />
    <path
      d="M17.8098 3.71595C17.882 3.71595 19.7227 2.79642 19.7227 2.79642C19.7227 2.79642 20.6681 4.70939 19.4563 5.79907C18.2446 6.88876 17.9782 6.27173 17.3973 6.91282C16.9538 7.40267 17.179 8.41501 17.179 8.41501L20.7798 11.8766C20.7798 11.8766 20.9809 12.2427 20.8365 12.5091C20.7334 12.6981 19.5216 14.0542 18.5832 15.0288C18.1604 15.467 17.5709 15.6149 17.2512 15.5375C16.452 15.3433 16.3316 14.7142 16.1856 13.6005C16.0395 12.4867 15.0804 12.5039 14.7315 12.5589C13.9959 12.6758 13.5163 13.1055 13.5163 13.1055C13.5163 13.1055 9.18508 7.88564 9.23321 7.73954C9.28133 7.59345 9.45149 6.50376 8.94274 6.04485C8.43399 5.58423 7.41821 5.35048 7.02977 5.08407C6.64305 4.81767 6.59149 4.31064 6.66196 3.81907C6.73243 3.32751 9.86399 3.33267 9.86399 3.33267C9.86399 3.33267 15.2643 6.31126 15.2901 6.19095C15.3141 6.06376 17.8098 3.71595 17.8098 3.71595Z"
      fill="#B0B0AF"
    />
    <path
      d="M15.1456 4.29516C15.2763 3.81735 15.1267 2.64345 16.0394 1.86657C16.952 1.0897 18.3717 1.18595 19.2259 2.00235C20.0802 2.81876 20.2177 4.3536 19.207 5.36423C18.1964 6.37485 17.7306 5.8111 17.1669 6.35595C16.6031 6.90079 16.7011 7.34766 17.05 7.67766C17.4006 8.00766 20.8794 11.6428 20.7814 11.8749C20.6834 12.1069 18.3133 14.7899 17.9249 14.9841C17.5364 15.1783 16.8558 15.1594 16.72 14.5183C16.5842 13.8772 16.818 12.595 15.8452 12.2633C14.8741 11.9333 14.4461 12.2049 13.4939 13.2155C12.5417 14.2261 12.1138 15.333 12.8906 15.8967C13.6675 16.4605 14.6403 16.2267 15.0288 16.8884C15.4172 17.5502 14.8345 18.1517 13.805 19.1039C12.7755 20.0561 11.978 20.833 11.8422 20.7367C11.7064 20.6388 8.75189 17.5106 8.46142 17.1806C8.16923 16.8506 7.60548 16.5584 7.06236 17.0638C6.51751 17.5691 6.42126 19.2208 4.12845 19.2208C1.83564 19.2208 1.56064 16.7338 2.37704 15.7042C3.19345 14.6747 4.99985 14.5767 5.03939 13.8772C5.05657 13.5558 4.06485 12.6895 3.17454 11.7597C2.12782 10.6649 1.15501 9.5047 1.11376 9.36891C1.03642 9.11626 3.2897 6.90079 3.71767 6.5897C4.14564 6.2786 4.63032 6.47282 4.86407 6.72548C5.09782 6.97813 5.15626 7.75501 5.35048 8.20188C5.5447 8.64876 6.45735 10.5927 8.65392 8.3772C10.8299 6.18063 8.77079 5.22845 8.07126 5.03423C7.37173 4.84001 6.86814 4.77641 6.6722 4.06313C6.51751 3.49938 7.37173 2.83938 8.26548 1.98345C9.15923 1.12751 9.68345 0.680634 9.9172 0.680634C10.1509 0.680634 13.2791 4.04251 13.6881 4.43095C14.0972 4.81938 14.3481 4.91735 14.6403 4.83829C14.9308 4.76266 15.0872 4.51001 15.1456 4.29516Z"
      fill="url(#paint0_radial_633_45302)"
    />
    <defs>
      <radialGradient
        cx="0"
        cy="0"
        gradientTransform="translate(10.6859 -4.86407) scale(20.4918)"
        gradientUnits="userSpaceOnUse"
        id="paint0_radial_633_45302"
        r="1"
      >
        <stop
          offset="0.5082"
          stopColor="#B7D118"
        />
        <stop
          offset="0.5721"
          stopColor="#B2D019"
        />
        <stop
          offset="0.6427"
          stopColor="#A5CD1D"
        />
        <stop
          offset="0.7167"
          stopColor="#8FC922"
        />
        <stop
          offset="0.7928"
          stopColor="#70C22A"
        />
        <stop
          offset="0.8707"
          stopColor="#48BA34"
        />
        <stop
          offset="0.9489"
          stopColor="#18B040"
        />
        <stop
          offset="0.9813"
          stopColor="#02AB46"
        />
      </radialGradient>
    </defs>
  </svg>
);

export default EmPuzzleIcon;
